import React, { useState, useEffect } from 'react';
import AdsSection from './AdsSection';
import { ThreeDot } from 'react-loading-indicators'; // Uporabno za prikaz nalaganja

const RecentlyViewedAds = () => {
    const [recentAds, setRecentAds] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchRecentAdsDetails = async () => {
            // 1. Preberi ID-je iz localStorage
            const viewedItems = JSON.parse(localStorage.getItem('nazadnjeOgledano')) || [];
            
            // Izvlečemo samo ID-je iz objektov {id: ..., url: ...}
            const viewedIds = viewedItems.map(item => item.id);

            // 2. Če ni ogledanih oglasov, ne naredimo ničesar
            if (viewedIds.length === 0) {
                setLoading(false);
                return;
            }

            try {
                // 3. Pošlji seznam ID-jev na backend z metodo POST
                const response = await fetch(`${process.env.REACT_APP_API_URL}/getRecentlyViewedListings`, {
                    method: 'POST', // Uporabimo POST
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    // V telo zahtevka dodamo ID-je v JSON formatu
                    body: JSON.stringify({ ids: viewedIds }), 
                });

                if (!response.ok) {
                    throw new Error('Napaka pri pridobivanju podatkov o oglasih.');
                }

                const data = await response.json(); // Pričakujemo { listings: [...] }

                // 4. Preoblikujemo podatke, če je potrebno (v tem primeru verjetno ne bo, ker backend že vrne pravi format)
                const transformedAds = data.listings.map(item => ({
                  id: item.id,
                  images: item.images,
                  category: item.category?.name || 'Brez kategorije',
                  title: item.title,
                  location: item.seller?.location || null,
                  price: item.price,
                  created_at: item.created_at,
                }));

                setRecentAds(transformedAds);

            } catch (error) {
                console.error('Failed to fetch recently viewed items:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchRecentAdsDetails();
    }, []); // Izvede se samo enkrat ob nalaganju komponente

    // Če se nalaga ali ni oglasov, ne prikažemo ničesar (ali pa loader)
    if (loading) {
        return null; // ali <ThreeDot ... /> če želite prikazati nalaganje
    }

    if (recentAds.length === 0) {
        return null;
    }

    return (
        <AdsSection
            title="Vaši nedavni ogledi"
            items={recentAds}
            // Gumb za "vse oglase" tukaj verjetno ni smiseln
        />
    );
};

export default RecentlyViewedAds;